export default "__VITE_ASSET__CWSvBMEo__"